import { ZAttrMeta, ZAttrType } from "./ZAttrMeta";

/**
 * Скалярные типы атрибутов, которые могут использоваться для отображения и идентификации записей
 */
const scalarAttrTypes = new Set<ZAttrType>([
  "string",
  "number",
  // "boolean", пока что не нужны, но логично, что далее могут понадобиться
  // "dateTime",
]);

/**
 * Проверяет, является ли атрибут скалярным (не составным типом)
 */
export const isScalarAttrType = (attr: ZAttrMeta): boolean =>
  scalarAttrTypes.has(attr.type.name);

/**
 * Фильтрует массив атрибутов, оставляя только скалярные типы
 */
export const filterScalarAttrs = (attrs: ZAttrMeta[]): ZAttrMeta[] =>
  attrs.filter(isScalarAttrType);
